<template>
  <div class="min-h-screen bg-gray-50">
    <!-- 页面标题 -->
    <div class="bg-white shadow-sm border-b">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between h-16">
          <div>
            <h1 class="text-2xl font-bold text-gray-900">{{ $store.getters.t('head_agent') }}</h1>
            <p class="text-sm text-gray-600">{{ $store.getters.t('head_agent_desc') }}</p>
          </div>
          <div class="flex items-center space-x-4">
            <div class="flex items-center space-x-2">
              <div class="w-3 h-3 bg-green-500 rounded-full"></div>
              <span class="text-sm text-gray-600">{{ $store.getters.t('running') }}</span>
            </div>
            <button class="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors">
              <i class="fas fa-cog mr-2"></i>
              {{ $store.getters.t('config') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

      <!-- 实时监控面板 -->
      <div class="bg-white rounded-lg shadow-sm border p-6">
        <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <i class="fas fa-chart-line mr-2 text-purple-500"></i>
          实时监控面板
        </h3>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div class="text-center p-4 bg-purple-50 rounded-lg">
            <div class="text-2xl font-bold text-purple-600">156</div>
            <div class="text-sm text-gray-600">今日处理请求</div>
          </div>
          <div class="text-center p-4 bg-blue-50 rounded-lg">
            <div class="text-2xl font-bold text-blue-600">98.5%</div>
            <div class="text-sm text-gray-600">成功率</div>
          </div>
          <div class="text-center p-4 bg-green-50 rounded-lg">
            <div class="text-2xl font-bold text-green-600">2.3s</div>
            <div class="text-sm text-gray-600">平均响应时间</div>
          </div>
          <div class="text-center p-4 bg-yellow-50 rounded-lg">
            <div class="text-2xl font-bold text-yellow-600">12</div>
            <div class="text-sm text-gray-600">活跃Agent</div>
          </div>
        </div>
      </div>
      <!-- 工作流程状态 -->
      <div class="bg-white rounded-lg shadow-sm border p-6 mb-8">
        <h2 class="text-lg font-semibold text-gray-900 mb-4">{{ $store.getters.t('workflow_status') }}</h2>
        <div class="grid grid-cols-1 md:grid-cols-5 gap-4">
          <!-- 意图识别 -->
          <div class="bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg p-4">
            <div class="flex items-center justify-between mb-2">
              <h3 class="font-medium">{{ $store.getters.t('intent_recognition') }}</h3>
              <i class="fas fa-brain text-xl"></i>
            </div>
            <div class="text-sm opacity-90">
              <div class="mb-1">{{ $store.getters.t('status') }}: <span class="font-semibold">{{ $store.getters.t('active_status') }}</span></div>
              <div>{{ $store.getters.t('processing_requests') }}: <span class="font-semibold">12</span> {{ $store.getters.t('requests') }}</div>
            </div>
          </div>

          <!-- 目标拆解 -->
          <div class="bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg p-4">
            <div class="flex items-center justify-between mb-2">
              <h3 class="font-medium">{{ $store.getters.t('goal_decomposition') }}</h3>
              <i class="fas fa-sitemap text-xl"></i>
            </div>
            <div class="text-sm opacity-90">
              <div class="mb-1">{{ $store.getters.t('status') }}: <span class="font-semibold">{{ $store.getters.t('active_status') }}</span></div>
              <div>{{ $store.getters.t('decomposed_goals') }}: <span class="font-semibold">8</span> {{ $store.getters.t('goals') }}</div>
            </div>
          </div>

          <!-- Agent分解 -->
          <div class="bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-lg p-4">
            <div class="flex items-center justify-between mb-2">
              <h3 class="font-medium">{{ $store.getters.t('agent_decomposition') }}</h3>
              <i class="fas fa-users-cog text-xl"></i>
            </div>
            <div class="text-sm opacity-90">
              <div class="mb-1">{{ $store.getters.t('status') }}: <span class="font-semibold">{{ $store.getters.t('active_status') }}</span></div>
              <div>{{ $store.getters.t('assigned_tasks') }}: <span class="font-semibold">15</span> {{ $store.getters.t('tasks') }}</div>
            </div>
          </div>

          <!-- Agent分发 -->
          <div class="bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg p-4">
            <div class="flex items-center justify-between mb-2">
              <h3 class="font-medium">{{ $store.getters.t('agent_distribution') }}</h3>
              <i class="fas fa-share-alt text-xl"></i>
            </div>
            <div class="text-sm opacity-90">
              <div class="mb-1">{{ $store.getters.t('status') }}: <span class="font-semibold">{{ $store.getters.t('active_status') }}</span></div>
              <div>{{ $store.getters.t('distributed_tasks') }}: <span class="font-semibold">23</span> {{ $store.getters.t('tasks') }}</div>
            </div>
          </div>

          <!-- 结果处理 -->
          <div class="bg-gradient-to-r from-red-500 to-red-600 text-white rounded-lg p-4">
            <div class="flex items-center justify-between mb-2">
              <h3 class="font-medium">{{ $store.getters.t('result_processing') }}</h3>
              <i class="fas fa-chart-line text-xl"></i>
            </div>
            <div class="text-sm opacity-90">
              <div class="mb-1">{{ $store.getters.t('status') }}: <span class="font-semibold">{{ $store.getters.t('active_status') }}</span></div>
              <div>{{ $store.getters.t('processed_results') }}: <span class="font-semibold">19</span> {{ $store.getters.t('results') }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 输入源监控 -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
        <!-- 主播精灵输入 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
            <i class="fas fa-user-tie mr-2 text-yellow-500"></i>
            主播精灵输入
          </h3>
          <div class="space-y-4">
            <div class="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
              <div>
                <div class="font-medium text-gray-900">对话请求</div>
                <div class="text-sm text-gray-600">用户: "帮我分析今天的直播数据"</div>
              </div>
              <span class="text-xs bg-yellow-200 text-yellow-800 px-2 py-1 rounded">处理中</span>
            </div>
            <div class="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
              <div>
                <div class="font-medium text-gray-900">观察数据</div>
                <div class="text-sm text-gray-600">直播时长: 3.5小时, 观看人数: 1,234</div>
              </div>
              <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">已完成</span>
            </div>
            <div class="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
              <div>
                <div class="font-medium text-gray-900">建议生成</div>
                <div class="text-sm text-gray-600">基于数据分析的优化建议</div>
              </div>
              <span class="text-xs bg-blue-200 text-blue-800 px-2 py-1 rounded">新</span>
            </div>
          </div>
        </div>

        <!-- 泛娱乐插件智能体输入 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
            <i class="fas fa-robot mr-2 text-yellow-500"></i>
            泛娱乐插件智能体输入
          </h3>
          <div class="space-y-4">
            <div class="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
              <div>
                <div class="font-medium text-gray-900">话术生成</div>
                <div class="text-sm text-gray-600">为直播开场生成话术模板</div>
              </div>
              <span class="text-xs bg-yellow-200 text-yellow-800 px-2 py-1 rounded">处理中</span>
            </div>
            <div class="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
              <div>
                <div class="font-medium text-gray-900">数据分析</div>
                <div class="text-sm text-gray-600">粉丝增长趋势分析</div>
              </div>
              <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">已完成</span>
            </div>
            <div class="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
              <div>
                <div class="font-medium text-gray-900">自动跟播</div>
                <div class="text-sm text-gray-600">热门话题自动跟播策略</div>
              </div>
              <span class="text-xs bg-blue-200 text-blue-800 px-2 py-1 rounded">新</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 输出目标监控 -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
        <!-- 前端平台输出 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
            <i class="fas fa-desktop mr-2 text-pink-500"></i>
            前端平台输出
          </h3>
          <div class="grid grid-cols-2 gap-3">
            <div class="p-3 bg-pink-50 rounded-lg">
              <div class="font-medium text-gray-900 text-sm">线索管理</div>
              <div class="text-xs text-gray-600">更新: 5分钟前</div>
            </div>
            <div class="p-3 bg-pink-50 rounded-lg">
              <div class="font-medium text-gray-900 text-sm">主播管理</div>
              <div class="text-xs text-gray-600">更新: 2分钟前</div>
            </div>
            <div class="p-3 bg-pink-50 rounded-lg">
              <div class="font-medium text-gray-900 text-sm">直播管理</div>
              <div class="text-xs text-gray-600">更新: 1分钟前</div>
            </div>
            <div class="p-3 bg-pink-50 rounded-lg">
              <div class="font-medium text-gray-900 text-sm">内容剪辑</div>
              <div class="text-xs text-gray-600">更新: 3分钟前</div>
            </div>
            <div class="p-3 bg-pink-50 rounded-lg">
              <div class="font-medium text-gray-900 text-sm">收益分析</div>
              <div class="text-xs text-gray-600">更新: 10分钟前</div>
            </div>
            <div class="p-3 bg-pink-50 rounded-lg">
              <div class="font-medium text-gray-900 text-sm">任务评估</div>
              <div class="text-xs text-gray-600">更新: 15分钟前</div>
            </div>
          </div>
        </div>

        <!-- 后端服务输出 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
            <i class="fas fa-server mr-2 text-green-500"></i>
            后端服务输出
          </h3>
          <div class="space-y-3">
            <div class="flex items-center justify-between p-3 bg-green-50 rounded-lg">
              <div>
                <div class="font-medium text-gray-900">数据存储</div>
                <div class="text-sm text-gray-600">用户行为数据已同步</div>
              </div>
              <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">成功</span>
            </div>
            <div class="flex items-center justify-between p-3 bg-green-50 rounded-lg">
              <div>
                <div class="font-medium text-gray-900">API调用</div>
                <div class="text-sm text-gray-600">外部服务接口调用</div>
              </div>
              <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">成功</span>
            </div>
            <div class="flex items-center justify-between p-3 bg-green-50 rounded-lg">
              <div>
                <div class="font-medium text-gray-900">日志记录</div>
                <div class="text-sm text-gray-600">系统操作日志已记录</div>
              </div>
              <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">成功</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'HeadAgent',
  data() {
    return {
      // 可以添加数据
    }
  },
  methods: {
    // 可以添加方法
  }
}
</script>

<style scoped>
/* 可以添加样式 */
</style> 